import { useContext, useLayoutEffect, useRef, useState } from "react";
import { BurgerButtonBig, ButtonRound, HeaderBig, LearnMore } from "../common/Common";
import './AboutUs.css';
import { LocaleContext, ScrollContext } from "../common/App";
import { Footer } from "./WebsiteCommon";
import { useIndexUpdate } from "../common/hooks";
import { sanitizeStr } from "../common/util";

export function AboutUs(props) {
    const locale = useContext(LocaleContext);

    useIndexUpdate(props.indexUpdate, locale);


    return (
        <div className="about_us">
            <img className="img_width" src="/customer/images/about_us_1.jpg" alt={locale.msgs.ABOUT_US_IMG_1_ALT_TEXT}></img>
            <div className="text_box">
                <h1 className="text_big_big head_after_img">{locale.msgs.ABOUT_US_LONG}</h1>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.ABOUT_US_DESCR}}></div>
            </div>

            <div id="team_box">
                <div className="text_big_big">{locale.msgs.M_N_TEAM}</div>

                <MainTeamMember img="/customer/images/about_us_team_1.jpg" name={locale.msgs.TEAM_MEMBER_NADJA_NAME} role={locale.msgs.TEAM_MEMBER_NADJA_ROLE} text={locale.msgs.TEAM_MEMBER_NADJA_TEXT} alt={locale.msgs.ABOUT_US_TEAM_IMG_1_ALT_TEXT} />
                <MainTeamMember img="/customer/images/about_us_team_2.jpg" name={locale.msgs.TEAM_MEMBER_TOMMY_NAME} role={locale.msgs.TEAM_MEMBER_TOMMY_ROLE} text={locale.msgs.TEAM_MEMBER_TOMMY_TEXT} alt={locale.msgs.ABOUT_US_TEAM_IMG_2_ALT_TEXT} />
                <MainTeamMember img="/customer/images/about_us_team_3.jpg" name={locale.msgs.TEAM_MEMBER_NELLY_NAME} role={locale.msgs.TEAM_MEMBER_NELLY_ROLE} text={locale.msgs.TEAM_MEMBER_NELLY_TEXT} alt={locale.msgs.ABOUT_US_TEAM_IMG_3_ALT_TEXT} />
                <MainTeamMember img="/customer/images/about_us_team_4.jpg" name={locale.msgs.TEAM_MEMBER_FRITZ_NAME} role={locale.msgs.TEAM_MEMBER_FRITZ_ROLE} text={locale.msgs.TEAM_MEMBER_FRITZ_TEXT} alt={locale.msgs.ABOUT_US_TEAM_IMG_4_ALT_TEXT} />
                <MainTeamMember img="/customer/images/about_us_team_5.jpg" name={locale.msgs.TEAM_MEMBER_MAIKE_NAME} role={locale.msgs.TEAM_MEMBER_MAIKE_ROLE} text={locale.msgs.TEAM_MEMBER_MAIKE_TEXT} alt={locale.msgs.ABOUT_US_TEAM_IMG_5_ALT_TEXT} />
                <MainTeamMember img="/customer/images/about_us_team_6.jpg" name={locale.msgs.TEAM_MEMBER_IVO_NAME} role={locale.msgs.TEAM_MEMBER_IVO_ROLE} text={locale.msgs.TEAM_MEMBER_IVO_TEXT} alt={locale.msgs.ABOUT_US_TEAM_IMG_6_ALT_TEXT} />
                <MainTeamMember img="/customer/images/about_us_team_7.jpg" name={locale.msgs.TEAM_MEMBER_TOBI_NAME} role={locale.msgs.TEAM_MEMBER_TOBI_ROLE} text={locale.msgs.TEAM_MEMBER_TOBI_TEXT} alt={locale.msgs.ABOUT_US_TEAM_IMG_7_ALT_TEXT} />

                {/*
                <div className="other_team_member_box">
                    <OtherTeamMember img="./nadja.PNG"/>
                    <OtherTeamMember img="./nadja.PNG"/>
                    <OtherTeamMember img="./nadja.PNG"/>
                    <OtherTeamMember img="./nadja.PNG"/>
                </div>
                */}

            </div>

            <Footer />
        </div>
    );
}

export function MainTeamMember(props) {
    const mainTeamMemberImgRef = useRef();
    const [mainTeamMemberHeight, setMainTeamMemberHeight] = useState(0);
    const [imageLoaded, setImageLoaded] = useState(false);

    useLayoutEffect(() => {
        function setImgWidth() {
            setMainTeamMemberHeight(mainTeamMemberImgRef.current.clientWidth);
        }

        setImgWidth();

        window.addEventListener("resize", setImgWidth);
        return () => window.removeEventListener("resize", setImgWidth);
    }, [imageLoaded]);

    return (
        <div className="main_team_member">
            <img ref={mainTeamMemberImgRef} alt={props.alt} className="main_team_member_img" src={props.img} style={{height: mainTeamMemberHeight}}
                    onLoad={(e) => setImageLoaded(true)}></img>
            <div className="main_team_member_name" dangerouslySetInnerHTML={{__html: sanitizeStr(props.name)}}></div>
            <div className="main_team_member_role" dangerouslySetInnerHTML={{__html: sanitizeStr(props.role)}}></div>
            <div className="main_team_member_text text" dangerouslySetInnerHTML={{__html: sanitizeStr(props.text)}}></div>
        </div>
    );
}

export function OtherTeamMember(props) {
    const locale = useContext(LocaleContext);
    const [imgHeight, setImgHeight] = useState(0);
    const [imageLoaded, setImageLoaded] = useState(false);
    const imgRef = useRef();

    useLayoutEffect(() => {
        function setImgWidth() {
            setImgHeight(imgRef.current.clientWidth);
        }

        setImgWidth();

        window.addEventListener("resize", setImgWidth);
        return () => window.removeEventListener("resize", setImgWidth);
    }, [imageLoaded]);

    return (
        <div className="other_team_member">
            <img ref={imgRef} style={{height: imgHeight}} className="other_team_member_img" src={props.img} onLoad={(e) => setImageLoaded(true)}></img>
            <div className="other_team_member_name">{locale.msgs.MAIN_TEAM_MEMBER_NAME}</div>
            <div className="other_team_member_role">{locale.msgs.MAIN_TEAM_MEMBER_ROLE}</div>
        </div>
    )
}
